import { airbnb } from './airbnb'
import { digitalOcean } from './digitalOcean'
import { robinhood } from './robinhood'
import { spacex } from './spacex'

export const FinishedSecuritiesMock = [airbnb, robinhood, digitalOcean, spacex]
